import { Button, Flex, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import type { NotificationData } from "@mantine/notifications";

type ShowCustomNotificationProps = {
  actionButton?: {
    text: string;
    action: () => void;
  };
} & NotificationData;

export const showCustomNotification = ({ actionButton, ...props }: ShowCustomNotificationProps) => {
  const id = notifications.show({
    icon: " ", // Trick
    ...props,
    ...(actionButton && {
      message: (
        <Stack gap="sm">
          {props.message}

          {actionButton && (
            <Flex justify="end" m="sm">
              <Button
                variant="white"
                onClick={actionButton.action}
                ff="text"
                tt="uppercase"
                style={{ minWidth: "fit-content" }}
              >
                {actionButton.text}
              </Button>
            </Flex>
          )}
        </Stack>
      ),
    }),
  });

  return {
    hide: () => notifications.hide(id),
    update: (data: Omit<NotificationData, "id">) => {
      notifications.update({ id, ...data });
    },
  };
};
